import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ExcelUpload } from "./ExcelUpload";
import { MailingRecordsTable } from "./MailingRecordsTable";
import { DuplicateReview } from "./DuplicateReview";
import { MelissaImport } from "./MelissaImport";
import { MailingHistoryChart } from "./MailingHistoryChart";
import { MailingQueryExport } from "./MailingQueryExport";
import { FileSpreadsheet, Table as TableIcon, Copy, ShieldCheck, BarChart3, Download } from "lucide-react";

export default function MailingRecordsPage() {
  const [refreshKey, setRefreshKey] = useState(0);
  const [activeTab, setActiveTab] = useState("records");

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Mailing Records</h1>
        <p className="text-muted-foreground">Manage your seller mailing database</p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList>
          <TabsTrigger value="records" className="flex items-center gap-1.5">
            <TableIcon className="h-4 w-4" /> Records
          </TabsTrigger>
          <TabsTrigger value="analytics" className="flex items-center gap-1.5">
            <BarChart3 className="h-4 w-4" /> Analytics
          </TabsTrigger>
          <TabsTrigger value="duplicates" className="flex items-center gap-1.5">
            <Copy className="h-4 w-4" /> Duplicates
          </TabsTrigger>
          <TabsTrigger value="import" className="flex items-center gap-1.5">
            <FileSpreadsheet className="h-4 w-4" /> Import
          </TabsTrigger>
          <TabsTrigger value="melissa" className="flex items-center gap-1.5">
            <ShieldCheck className="h-4 w-4" /> Melissa Import
          </TabsTrigger>
          <TabsTrigger value="export" className="flex items-center gap-1.5">
            <Download className="h-4 w-4" /> Export
          </TabsTrigger>
        </TabsList>

        <TabsContent value="records">
          <MailingRecordsTable refreshKey={refreshKey} />
        </TabsContent>

        <TabsContent value="analytics">
          <MailingHistoryChart />
        </TabsContent>

        <TabsContent value="duplicates">
          <DuplicateReview onComplete={() => { setRefreshKey(k => k + 1); setActiveTab("records"); }} />
        </TabsContent>

        <TabsContent value="import">
          <ExcelUpload onImportComplete={() => setRefreshKey(k => k + 1)} />
        </TabsContent>

        <TabsContent value="melissa">
          <MelissaImport onImportComplete={() => setRefreshKey(k => k + 1)} />
        </TabsContent>

        <TabsContent value="export">
          <MailingQueryExport />
        </TabsContent>
      </Tabs>
    </div>
  );
}